import createReducer from '../createReducer';
import {TEticket} from './eTicket.type';

const initialState: TEticket = {
    data: null,
    oid: null,
    error: null,
    getETicketXHR: null,
    getETicketScanStatusXHR: null,
};

const reducer = createReducer('eTicket', initialState);

export default reducer;
